export default __webpack_public_path__ + "static/media/fa-regular-400.c3c2ab4f.woff2";